import PropTypes from "prop-types";

const paypalHandlersPropTypes = {
  // (paypalActions) -> void
  onAuthorize: PropTypes.func.isRequired,
  // () -> void
  onCancel: PropTypes.func.isRequired,
  // (resolve, reject) -> void
  onClick: PropTypes.func,
  // (paypalData, paypalActions) -> void
  onError: PropTypes.func.isRequired,
  // (paypalData, paypalActions) -> void
  payment: PropTypes.func.isRequired,
  // (error) -> void
  validate: PropTypes.func
};

const stripeHandlersPropTypes = {
  onError: PropTypes.func.isRequired,
  onSubmission: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired
};

export { paypalHandlersPropTypes, stripeHandlersPropTypes };
